module.exports = __webpack_public_path__ + "images/application/illustrations/banner-pipes-bg-large-5fa94ee1.svg";